module.exports = __webpack_public_path__ + "img/pantalla 6-1 mobile.0bf80e9f.svg";